import type { MetaFunction } from "@remix-run/node";

import { buildMeta, langFromParams } from "./seo/meta";

/**
 * Fallback only. A child route that exports `meta` replaces this wholesale, and
 * every content route does. The site-wide JSON-LD therefore lives in
 * seo/OrganizationSchema.tsx, rendered straight into the root <head>.
 */
const RootMeta: MetaFunction = ({ params }) => {
  const lang = langFromParams(params);

  return buildMeta({
    lang,
    path: "/",
    title: "SkillSynergy | Live coding and AI courses",
    description:
      "Live, hands-on programming and AI courses for every level. Learn software engineering step by step with expert instructors, in group or one-to-one classes.",
  });
};

export default RootMeta;
